<template lang="pug">
div.whatsapp-template-settings(:class="{ 'whatsapp-template-settings-dark': isDark }")
  div.template-header
    div
      h2.fonte Templates IntraWhats
      span.fonteMini Configure as mensagens automaticas do ciclo de venda.
    v-btn(color="#1f8f55" dark rounded :loading="saving" @click="save")
      v-icon(left small) mdi-content-save-outline
      | Salvar

  div.template-grid
    div.template-card(v-for="event in templateEvents" :key="event.value")
      div.template-card-title
        v-avatar(size="38" color="#e8f7ef")
          v-icon(color="#1f8f55" size="21") {{ event.icon }}
        div
          strong.fonte {{ event.title }}
          small.fonteMini {{ event.description }}
        v-spacer
        v-switch(v-model="localTemplates[event.value].active" inset dense hide-details color="#1f8f55")
      v-textarea(
        v-model="localTemplates[event.value].text"
        outlined
        dense
        rows="3"
        label="Mensagem"
        hide-details
      )
      div.token-row
        v-chip(x-small v-for="token in tokens" :key="`${event.value}-${token}`") {{ token }}
      div(v-if="localTemplates[event.value].poll" class="poll-options")
        small.fonteMini Opcoes de resposta
        div.poll-option(v-for="(option, index) in localTemplates[event.value].poll.options" :key="option.id || index")
          v-text-field(v-model="option.text" outlined dense hide-details :label="`Opcao ${index + 1}`")
</template>

<script>
export default {
  props: {
    whatsapp_flow_templates: {
      type: Object,
      default: () => ({})
    },
    saving: Boolean
  },
  data() {
    return {
      templateEvents: [
        { value: "approval_request", title: "Aprovacao", icon: "mdi-check-decagram-outline", description: "Pedido de aprovacao do orcamento." },
        { value: "delivery_confirmation", title: "Entrega", icon: "mdi-truck-delivery-outline", description: "Confirmacao para receber ou reagendar." },
        { value: "assembly_offer", title: "Montagem", icon: "mdi-tools", description: "Oferta de montagem apos a entrega." },
        { value: "collection_reminder", title: "Cobranca", icon: "mdi-cash-clock", description: "Lembrete de pendencia financeira." }
      ],
      tokens: ["{{client_name}}", "{{sale_number}}", "{{delivery_date}}", "{{delivery_hour}}", "{{appointment_time}}"],
      localTemplates: {}
    };
  },
  computed: {
    isDark() {
      return localStorage.dark === "true";
    },
  },
  watch: {
    whatsapp_flow_templates: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localTemplates = this.normalizeTemplates(value || {});
      }
    }
  },
  methods: {
    defaultTemplates() {
      return {
        approval_request: {
          active: true,
          text: "Ola {{client_name}}! Seu orcamento #{{sale_number}} esta pronto. Deseja aprovar a producao?",
          poll: { options: [{ id: "approve", text: "Aprovar" }, { id: "reject", text: "Reprovar" }] }
        },
        delivery_confirmation: {
          active: true,
          text: "Ola {{client_name}}! Sua entrega da venda #{{sale_number}} esta em rota. Voce pode receber normalmente ou prefere reagendar?",
          poll: { options: [{ id: "receive", text: "Receber normalmente" }, { id: "reschedule", text: "Reagendar" }] }
        },
        assembly_offer: {
          active: true,
          text: "Ola {{client_name}}! Sua entrega foi concluida. Deseja agendar a montagem?",
          poll: { options: [{ id: "want_assembly", text: "Quero montagem" }, { id: "no_assembly", text: "Nao preciso" }] }
        },
        collection_reminder: {
          active: true,
          text: "Ola {{client_name}}! Identificamos uma pendencia financeira da venda #{{sale_number}}. Podemos ajudar com a regularizacao?",
          poll: { options: [{ id: "pay_now", text: "Quero regularizar" }, { id: "talk_to_attendant", text: "Falar com atendente" }] }
        }
      };
    },
    normalizeTemplates(value) {
      const defaults = this.defaultTemplates();
      return Object.keys(defaults).reduce((acc, key) => {
        const current = value[key] || {};
        acc[key] = {
          ...defaults[key],
          ...current,
          poll: defaults[key].poll
            ? {
              ...defaults[key].poll,
              ...(current.poll || {}),
              options: current.poll && Array.isArray(current.poll.options) && current.poll.options.length
                ? current.poll.options
                : defaults[key].poll.options
            }
            : null
        };
        return acc;
      }, {});
    },
    save() {
      this.$emit("save", this.localTemplates);
    }
  }
};
</script>

<style scoped>
.whatsapp-template-settings {
  color: #1f2a2e;
  padding-bottom: 24px;
}
.template-header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;
}
.template-header h2 {
  margin: 0;
}
.template-header span,
.template-card small,
.poll-options small {
  color: #607178;
}
.template-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
}
.template-card {
  background: #ffffff;
  border: 1px solid rgba(18, 140, 126, 0.12);
  border-radius: 18px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.template-card-title {
  align-items: center;
  display: flex;
  gap: 10px;
}
.template-card-title div {
  min-width: 0;
}
.template-card-title strong,
.template-card-title small {
  display: block;
}
.token-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.poll-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.poll-option {
  min-width: 0;
}
.whatsapp-template-settings-dark,
.whatsapp-template-settings-dark .template-card {
  background: transparent;
  color: #e9edef;
}
.whatsapp-template-settings-dark .template-card {
  background: #111b21;
  border-color: #26343c;
  box-shadow: none;
}
.whatsapp-template-settings-dark .template-header span,
.whatsapp-template-settings-dark .template-card small,
.whatsapp-template-settings-dark .poll-options small {
  color: #aebac1;
}
.whatsapp-template-settings-dark ::v-deep .v-input__slot {
  background: #202c33 !important;
}
@media(max-width: 760px) {
  .template-header {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
